var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcSort(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "6px",
    height: "8px",
    viewBox: "0 0 6 8",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic_sort") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "UI-Design",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "46_My-playlist",
    transform: "translate(-1039, -248)",
    fill: "#738089"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic_sort",
    transform: "translate(1039, 248)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.46666667,1.06666667 L5.33333333,3.55555556 L5.33333333,3.55555556 L0,3.55555556 L1.86666667,1.06666667 C2.19803752,0.624838867 2.82483887,0.535295817 3.26666667,0.866666667 C3.34247233,0.923520916 3.40981242,0.990861001 3.46666667,1.06666667 Z",
    id: "Triangle"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.46666667,5.51111111 L5.33333333,8 L5.33333333,8 L0,8 L1.86666667,5.51111111 C2.19803752,5.06928331 2.82483887,4.97974026 3.26666667,5.31111111 C3.34247233,5.36796536 3.40981242,5.43530545 3.46666667,5.51111111 Z",
    id: "Triangle",
    transform: "translate(2.6667, 6.2222) scale(1, -1) translate(-2.6667, -6.2222)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSort);
export default __webpack_public_path__ + "static/media/ic_sort.acdcca57b8f054a8b65e8ef1c2c378c2.svg";
export { ForwardRef as ReactComponent };